document.addEventListener('DOMContentLoaded', function () {
  var baseOpts = {
    slidesPerView: 'auto',
    spaceBetween: 16,
    pagination: { el: '.swiper-pagination', clickable: true },
  };

  document.querySelectorAll('.servicesSwiper').forEach(function (el) {
    if (el.swiper) return;
    var section = el.closest('.services-section');
    var nav = section ? section.querySelector('.services-section__nav') : null;
    var nextEl = nav ? nav.querySelector('.services-section__arrow--next') : null;
    var prevEl = nav ? nav.querySelector('.services-section__arrow--prev') : null;
    new Swiper(el, Object.assign({}, baseOpts, {
      navigation: nextEl && prevEl ? { nextEl: nextEl, prevEl: prevEl } : false,
    }));
  });
});
